import React from 'react';

import {
  Typography,
  TableContainer,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Grid,
  Section,
  Link,
  IconButton,
} from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import Status from 'scenes/CustomAudiences/Audiences/components/Status';
import LookalikeAudienceDetails from 'scenes/CustomAudiences/LookalikeAudiences/components/LookalikeAudienceDetails';
import {
  LookalikeAudiencePartnerAudienceBasedFormCreate,
  PARTNER_AUDIENCE,
  PARTNER,
} from 'scenes/CustomAudiences/LookalikeAudiences/components/LookalikeAudienceForm';

const LookalikeAudiencesSection = ({ partnerAudience, partner, data }) => {
  const [childComponent, openChildComponent] = useChildComponent();

  const handleAdd = async () => {
    openChildComponent(LookalikeAudiencePartnerAudienceBasedFormCreate, {
      initialValues: {
        [PARTNER_AUDIENCE]: partnerAudience,
        [PARTNER]: partner,
      },
    });
  };

  const handleOpenLookalikeAudience = async (_e, { id }) => {
    openChildComponent(LookalikeAudienceDetails, {
      id: id,
    });
  };

  const count = data?.length || 0;

  return (
    <React.Fragment>
      <Section
        title={`Lookalike Audiences (${count})`}
        isCollapsable={!!count}
        initialOpen={false}
        action={
          <IconButton
            add
            tooltip={'Add Lookalike Audience'}
            onClick={handleAdd}
            data-cy-action={'add-lookalike-audience'}
          />
        }
        subTitle={count < 1 ? 'No lookalike audiences' : true}
      >
        {data && data.length ? (
          <TableContainer>
            <Table width={'100%'}>
              <TableBody>
                {data.map((item) => {
                  return (
                    <TableRow key={item.id}>
                      <TableCell col={'name'}>
                        <Grid direction={'column'}>
                          <Typography>
                            <Link
                              onClick={(e) =>
                                handleOpenLookalikeAudience(e, {
                                  id: item.id,
                                })
                              }
                            >
                              {item.name}
                            </Link>
                          </Typography>
                          <Status value={item.filterStatus} />
                        </Grid>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : null}
      </Section>
      {childComponent}
    </React.Fragment>
  );
};

export default LookalikeAudiencesSection;
